import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { networkTypeApi } from "./api";

export const useAddNetworkType = () => {
  return useSmartMutation((payload: any) =>
    networkTypeApi.addNetworkType(payload)
  );
};

export const useNetworkType = (params: {
  remote_utility_id: any;
  config_level: string;
  show_inactive: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ax.facilityType.facilityData(params),
    () => networkTypeApi.getNetworkType(params)
  );
};
export const useUpdateNetworkType = () => {
  return useSmartMutation((payload: any) =>
    networkTypeApi.updateNetworkType(payload)
  );
};

export const useSearchNetwokType = (params: {
  remote_utility_id: any;
  search_data: string;
  search_field?: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.ax.networkType.searchNetworkType(params),
    () => networkTypeApi.searchNetworkType(params),
    {
      enabled: !!params.search_data && params.search_data.trim().length > 0, // Only run query if search_data is provided and not empty
    }
  );
};

    export const useDeleteNetworkType = () => {
    return useSmartMutation(
      (params: { remote_utility_id: any; code: any }) =>
        networkTypeApi.deleteNetworkType(params),
    );
  };
